import { Home } from "lucide-react";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { usePageTitleOverrideOptional } from "../contexts/pageTitleOverride";
import { useAuthStore } from "../stores/authStore";

export default function NotFound() {
  const { t } = useTranslation();
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const titleOverride = usePageTitleOverrideOptional();
  const isEmbedded = typeof window !== "undefined" && window.self !== window.top;

  useEffect(() => {
    if (!isAuthenticated || !titleOverride) {
      return;
    }
    titleOverride.setOverride(t("notFound.title"));
    return () => {
      titleOverride.setOverride(null);
    };
  }, [isAuthenticated, t, titleOverride]);

  const shellClass = isAuthenticated
    ? "flex min-h-[50vh] flex-col items-center justify-center p-4 text-center"
    : "min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 p-4";

  const HomeLink = isEmbedded
    ? (
        <a
          href="/"
          target="_top"
          rel="noreferrer"
          className="btn-primary mt-6 inline-flex"
        >
          <Home className="w-5 h-5" />
          {t("notFound.backHome")}
        </a>
      )
    : (
        <Link to="/" className="btn-primary mt-6 inline-flex">
          <Home className="w-5 h-5" />
          {t("notFound.backHome")}
        </Link>
      );

  return (
    <div className={shellClass}>
      <div className="text-center">
        <p
          className="text-9xl font-bold text-gray-200 dark:text-gray-700"
          aria-hidden="true"
        >
          404
        </p>
        <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mt-4">
          {t("notFound.title")}
        </h2>
        <p className="text-gray-500 dark:text-gray-400 mt-2 max-w-md">
          {t("notFound.description")}
        </p>
        {HomeLink}
      </div>
    </div>
  );
}
